import { DealerEditHydration } from './single-dealer.interfaces';

/** Empty hydration state for a new or unloaded dealer */
export const EMPTY_DEALER_HYDRATION: DealerEditHydration = {
    userId: '',
    clientInformationId: '',
    initialEmail: '',
    userMetadata: null,
    firstName: '',
    lastName: '',
    contactPersonPhone: '',
    contactPerson: '',
    clientMetadata: null,
    businessName: '',
    dealerAlias: '',
    dealerId: '',
    city: '',
    state: '',
    region: '',
} as const;

/** Path to the global SVG sprite */
export const SPRITE_PATH = 'assets/icons/icons-sprite.svg';

/** Page size for the dealer licenses table (matches API default). */
export const SINGLE_DEALER_LICENSE_PAGE_SIZE = 10;

/** sessionStorage: map of dealer Auth `userId` → change-password cooldown end (epoch ms) */
export const DEALER_CHANGE_PASSWORD_COOLDOWN_STORAGE_KEY = 'nctv_admin_dealer_change_pwd_cooldown';

/** Minimum countdown (seconds) for Change password after a successful send when the API TTL is shorter. */
export const DEALER_CHANGE_PASSWORD_MIN_COOLDOWN_SECONDS = 5 * 60;

/** User-facing labels for the dealer save success message */
export const DEALER_SAVE_MESSAGES = {
    DEFAULT: 'Dealer and account details were updated successfully.',
    EMAIL_CHANGED:
        'Your changes have been saved. If you updated your email, check your inbox to verify the new address.',
    REFRESH_FAILED:
        'Your changes were saved, but this page could not be refreshed. Try reloading the browser.',
} as const;

/** Shown when force-password-change hits the server rate limit (502). */
export const DEALER_PASSWORD_CHANGE_LIMIT = {
    TITLE: 'Change password',
    MESSAGE:
        'Too many password reset requests. For security reasons, please wait a few minutes before trying again.',
} as const;

/** Display labels and tooltips */
export const DEALER_UI_LABELS = {
    PASSWORD_RESET_SENT: 'Password reset sent',
    CHANGES_SAVED: 'Changes saved',
    MODIFY: 'Modify',
    LICENSES: 'Licenses',
    SEARCH_PLACEHOLDER: 'Search by License Key or Alias',
    LICENSE_DELETE_TITLE: 'Delete license',
    LICENSE_DELETE_SUCCESS_TITLE: 'License deleted',
    LICENSE_DELETE_SUCCESS_MESSAGE: 'The license was deleted successfully.',
    DEALER_DELETE_SUCCESS_TITLE: 'Successfully Deleted',
} as const;
